export default function adressFullClient(adresse) {
  if (!adresse) {
    return '';
  }
  let adresseString = '';
  if (adresse.intitule1 !== null && adresse.intitule1) {
    adresseString += ' ' + adresse.intitule1;
  }
  if (adresse.intitule2 !== null && adresse.intitule2) {
    adresseString += ' ' + adresse.intitule2;
  }
  if (adresse.intitule3 !== null && adresse.intitule3) {
    adresseString += ' ' + adresse.intitule3;
  }
  if (adresseString.length > 0) {
    adresseString += ',';
  }
  if (adresse.adresse1 !== null && adresse.adresse1) {
    adresseString += ' ' + adresse.adresse1;
  }
  if (adresse.adresse2 !== null && adresse.adresse2) {
    adresseString += ' ' + adresse.adresse2;
  }
  if (adresse.adresse3 !== null && adresse.adresse3) {
    adresseString += ' ' + adresse.adresse3;
  }
  if (adresseString.length > 0) {
    adresseString += ',';
  }
  if (adresse.codePostal !== null && adresse.codePostal) {
    adresseString += ' ' + adresse.codePostal;
  }
  if (adresse.ville !== null && adresse.ville) {
    adresseString += ' ' + adresse.ville;
  }

  return adresseString.trim();
}
